import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import EmergencyResponseRecoveryDetails from '../../subdepartmentdetails/EmergencyResponseRecovery'


function EmergencyResponseRecovery() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Emergency Response and Recovery Operations || Emergency Management";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Emergency Management"
            title="Emergency Response Recovery"
            subtitledown="Department of Emergency Management"
           />
            <EmergencyResponseRecoveryDetails/>
        </div>
    </>
  )
}

export default EmergencyResponseRecovery